/* import __COLOCATED_TEMPLATE__ from './online-ordering-row.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
let OnlineOrderingRow = (_class = class OnlineOrderingRow extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
  }
  get hasMenus() {
    return this.args.hasMenus;
  }
  get hasLocations() {
    return this.args.hasLocations;
  }
  get hasGlobalPausedOrdering() {
    // This is to determine if the ordering is paused at the top level, not at a location level.
    // Currently it is being used for the setup guides, but the API request to change this does not seem to work.
    return false;
  }
  get isOrderingPaused() {
    // ordering is paused if all locations are paused. Locations cannot be 0 length.
    return this.args.isAllLocationOrderingPaused;
  }
  get isDisabled() {
    return this.args.disabled ?? false;
  }
  get displayStatus() {
    // When disabled, always show "Off"
    if (this.isDisabled) {
      return 'common.off';
    }

    // Normal logic when not disabled
    if (this.isOrderingPaused || this.hasGlobalPausedOrdering) {
      return 'common.off';
    }
    return 'common.on';
  }
  get unpausedLocationCount() {
    return this.args.unpausedLocationsCount;
  }
  get showAddMenuButton() {
    return !this.hasMenus;
  }
  get showAddLocationButton() {
    return this.hasMenus && !this.hasLocations;
  }

  // Ready to enable orders, show the "Turn on ordering" button.
  // Will only appear if top-level ordering is paused.
  get isReadyToShowEnableMessage() {
    return this.hasMenus && this.hasLocations && this.hasGlobalPausedOrdering;
  }
  handleAddMenu() {
    this.router.transitionTo('/items/menus');
  }
  handleAddLocation() {
    this.router.transitionTo('/locations');
  }
  handleTurnOnOrdering() {
    this.args.updateOrderingPause(false);
  }
  handleToggleOrders() {
    this.args.handleOrderingModalFlow();
  }
  onSave() {
    this.args.onSave();
    this.args.onClose();
  }
  handleCloseDialog() {
    this.args.onClose();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleAddMenu", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleAddMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleAddLocation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleAddLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTurnOnOrdering", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTurnOnOrdering"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleToggleOrders", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleToggleOrders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSave", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCloseDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCloseDialog"), _class.prototype), _class);
export { OnlineOrderingRow as default };